<!--
 * @Author: your name
 * @Date: 2022-06-15 09
-->
<template>
  <div class="maxsecondTitle">
    <div class="letter"><span>{{letter}}</span><div class="letter_text">{{enTitle}}</div></div>
    <div class="current_add">{{current_add}}</div>
    <div class="add_row">
      <img src="~@/assets/icon/home/erjiicon.png" alt="">
      <div class="erji-row">
        <div class="homeadd">您所在的位置：</div>
        <div class="homeadd">{{add_one}}/</div>
        <div class="homeadd">{{add_tow}}/</div>
        <div class="homedetails">{{add_three}}</div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props:{
    add_one:{
      type:String,
      default:''
    },
    add_tow:{
      type:String,
      default:''
    },
    add_three:{
      type:String,
      default:''
    },
    current_add:{
      type:String,
      default:'',
    },
    letter:{
      type:String,
      default:''
    },
    enTitle:{
      type:String,
      default:''
    },
  }
}
</script>
<style lang="scss" scoped>
.maxsecondTitle{
  margin-left: 3.8667vw;
  .letter{
    font-weight: 500;
    display: flex;
    align-items: flex-end;
    padding-top: 5.3333vw;
    span{
      font-size: 6.6667vw;
      color: #000000;
      margin-left: 0.6667vw;
      padding-top: 0.6667vw;

    }
    .letter_text{
      font-size: 4vw;
      color: #000000;
      margin-bottom: 0.8vw;
    }
  }
}
.erji-row{
    display: flex;
    margin-left: 1vw;
  .homeadd{
    font-size: 4vw;
    color: #A1A1A1;
  }
  .homedetails{
    font-size: 4vw;
    color: #000000;
    font-weight: 500;
  }
}
.current_add{
  font-size: 4vw;
  font-weight: 500;
  color: #000000;
  margin-top: 1.8667vw;
  margin-left: 7.2vw;
}
.add_row{
  display: flex;
  align-items: center;
  margin-top: 5.3333vw;
  img{
    width: 4.7333vw;
    height: 4.7333vw;
  }
}
</style>